<form [formGroup]="optionsForm" class="ap-margin-bottom-0 ap-margin-top-4">
    @for (option of options; track $index) {
        <ap-checkbox
            id="{{ option }}Option"
            [ariaDescribedby]="option | optionPipe | apContent"
            [label]="option | optionPipe | apContent"
            formControlName="{{ option }}"
            (click)="select()"
        >
        </ap-checkbox>

        @if (this.optionsState[option]) {
            @switch (option) {
                @case (optionQuestion.STUDENT_DEBT) {
                    <student-debt></student-debt>
                }
                @case (optionQuestion.PAYMENT_ACCOUNT_OVERDRAFT) {
                    <payment-account-overdraft></payment-account-overdraft>
                }
                @case (optionQuestion.MOBILE_PHONE_PAYMENT) {
                    <mobile-phone-payment></mobile-phone-payment>
                }
                @case (optionQuestion.OPEN_ENDED_CREDIT) {
                    <open-ended-credit></open-ended-credit>
                }
                @case (optionQuestion.CREDIT_CARD) {
                    <credit-card></credit-card>
                }
                @case (optionQuestion.PRIVATE_LEASE) {
                    <private-lease></private-lease>
                }
                @case (optionQuestion.PERSONAL_LOAN) {
                    <personal-loan></personal-loan>
                }
                @case (optionQuestion.PARTNER_ALIMONY) {
                    <partner-alimony></partner-alimony>
                }
            }
        }
        <hr />
    }
    <ap-checkbox
        id="noObligationsOption"
        label="{{ 'noObligations' | optionPipe | apContent }}"
        formControlName="noObligations"
        (click)="noObligations()"
    >
    </ap-checkbox>
</form>
@if (showError()) {
    <ap-notification status="error">
        {{ 'general.error.options.required' | apContent }}
    </ap-notification>
}
